import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  constructor(private http: HttpClient) { }

  getRoles(filters:any): Observable<any[]> {
    let params = {}
    if (filters != null) {
      for (let p in filters) {
        params[p] = filters[p];
      }
    }
    let url = `${environment.url}/crm/users`;
    return this.http.get<any[]>(url, { params });
  }
  getVariables(){
    let url = `${environment.url}/data/variable`;
    return this.http.get<any[]>(url);
  }
   getPermissionsByUserId(userId: number): Observable<any> {
    let url = `${environment.url}/crm/roles/permissions/?user=${userId}`;
    return this.http.get(url);
  }
  updateInformation(field: number, variable: number, user: number): Observable<any> {
    const body = {
      field: field,
      variable: variable,
      user: user
    };
    let url = `${environment.url}/crm/roles/permissions`
    return this.http.post(url, body);
  }

  deletePermissions(id: number): Observable<any> {
    let url = `${environment.url}/crm/roles/permissions/${id}`
    return this.http.delete(url);
  }
  updateLicence(user: number, has_license: boolean): Observable<any> {
    const body = {
      user, has_license
    };
    let url = `${environment.url}/crm/users/licence/`
    return this.http.post(url, body);
  }
}
